// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_VcO","cls2":"CreateSocialItemModal-cls2_JmQ CreateSocialItemModal-cls1_VcO"};